//*Libraries imports
import { z } from "zod";

export const ClientAddressSchema = z.object({
  refId: z.string().optional(),
  name: z.string().optional(),
  zip_code: z.string().optional(),
  street: z.string().optional(),
  number: z.string().optional(),
  complement: z.string().optional(),
  neighborhood: z.string().optional(),
  cityName: z.string().optional(),
  stateCode: z.string().optional(),
});

export type ClientAddress = z.infer<typeof ClientAddressSchema>;

export const CreditCardBrandSchema = z.enum([
  "VISA",
  "MASTERCARD",
  "AMERICAN_EXPRESS",
  "ELO",
  "HIPERCARD",
  "DINERS",
  "DISCOVER",
  "JCB",
  "AURA",
  "CASAS_BAHIA",
  "UNKNOWN",
]);

export type CreditCardBrand = z.infer<typeof CreditCardBrandSchema>;

export const ClientCreditCardSchema = z.object({
  creditCardNumber: z.string().optional(),
  creditCardBrand: CreditCardBrandSchema.optional(),
  creditCardToken: z.string().optional(),
});

export type ClientCreditCard = z.infer<typeof ClientCreditCardSchema>;

export const ClientSchema = z
  .object({
    _id: z.string().optional(),
    refId: z.string().optional(),
    name: z.string().optional(),
    business_name: z.string().optional(),
    ie: z.string().optional(),
    im: z.string().optional(),
    email: z.string().email().optional().or(z.literal("")),
    whatsapp: z.string().optional(),
    cnpj: z.string().optional(),
    cpf: z.string().optional(),
    customerId: z.string().optional(),
    places: z.array(ClientAddressSchema).optional(),
    creditCards: z.array(ClientCreditCardSchema).optional(),
    owner: z.string().optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
  })
  .catchall(z.any());

export type Client = z.infer<typeof ClientSchema>;
